// extracted by mini-css-extract-plugin
export var growableInput = "_6g-0";
export var tagContainer = "_6g-2";
export var textInput = "_6g-1";